import { render, staticRenderFns } from "./ProductCustomisationVariationInput.vue?vue&type=template&id=4a5cd360&scoped=true&"
import script from "./ProductCustomisationVariationInput.vue?vue&type=script&lang=js&"
export * from "./ProductCustomisationVariationInput.vue?vue&type=script&lang=js&"
import style0 from "./ProductCustomisationVariationInput.vue?vue&type=style&index=0&id=4a5cd360&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5cd360",
  null
  
)

export default component.exports